import { Formik, FormikConfig } from "formik";
import { withFormikDevtools } from "formik-devtools-extension";

import useGetLastProcessDate from "../../../api/useGetLastProcessDate";
import { useAccountLookupStore } from "../../../hooks/useAccountLookupStore";
import { useSearchBarParams } from "../../../hooks/useSearchBarParams";
import { formatUTCDate } from "../../../utils/dateFormatter";
import RequirementsSearchForm from "./RequirementsSearchForm";
import {
  RequirementsSearchBarValues,
  searchBarSchema,
} from "./utils/requirementsSchema";

export interface RequirementsSearchProps {
  isLoading: boolean;
  refetch: () => void;
}

export const RequirementsSearch = ({
  isLoading,
  refetch,
}: RequirementsSearchProps) => {
  const { accountNumber, setDates, setView } = useAccountLookupStore(state => ({
    accountNumber: state.accountNumber,
    setDates: state.setDates,
    setView: state.setView,
  }));

  const { data: lastProcessDate, isLoading: isLastProcessDateLoading } =
    useGetLastProcessDate({ enabled: !!accountNumber });

  const { initialParams, setParams } =
    useSearchBarParams<RequirementsSearchBarValues>({
      replaceSlashes: ["fromProcessDate", "toProcessDate"],
    });

  const processDateFormated = formatUTCDate(lastProcessDate);

  const onSubmit = (values: RequirementsSearchBarValues) => {
    setParams(values);
    setDates(values.fromProcessDate, values.toProcessDate);
    setView(values.view);
    setTimeout(refetch, 0);
  };

  if (isLastProcessDateLoading) return null;

  const formikConfig: FormikConfig<RequirementsSearchBarValues> = {
    initialValues: searchBarSchema.cast({
      fromProcessDate: initialParams.fromProcessDate || processDateFormated,
      toProcessDate: initialParams.toProcessDate || processDateFormated,
      view: initialParams.view || "details",
    }) as RequirementsSearchBarValues,
    onSubmit,
    validationSchema: searchBarSchema,
    enableReinitialize: true,
    validateOnMount: true,
  };

  return (
    <Formik {...formikConfig}>
      {formikProps => {
        withFormikDevtools(formikProps);
        return <RequirementsSearchForm isFetching={isLoading} />;
      }}
    </Formik>
  );
};
